import "./HexKeyboard.css";

const HexKeyboard = ({ updateSerialGen2Go, serialG2Short, togglePopup }) => {

    const handleButtonClick = (char) => {
        if (serialG2Short === undefined || serialG2Short === "") {
            updateSerialGen2Go(char);
        } else {
            updateSerialGen2Go(serialG2Short + char);
        }
    };

    const handleBackspace = () => {
        if (serialG2Short && serialG2Short.length > 0) {
            const updatedValue = serialG2Short.slice(0, -1);
            updateSerialGen2Go(updatedValue);
        }
    };

    return (
        <div className="hex-keyboard-wrapper">
            <div className="hex-keyboard">
                <div className="keyboard-row">
                    <button className="hex-letter" onClick={() => handleButtonClick('A')}>A</button>
                    <button className="hex-letter" onClick={() => handleButtonClick('B')}>B</button>
                    <button onClick={() => handleButtonClick('1')}>1</button>
                    <button onClick={() => handleButtonClick('2')}>2</button>
                    <button onClick={() => handleButtonClick('3')}>3</button>
                </div>
                <div className="keyboard-row">
                    <button className="hex-letter" onClick={() => handleButtonClick('C')}>C</button>
                    <button className="hex-letter" onClick={() => handleButtonClick('D')}>D</button>
                    <button onClick={() => handleButtonClick('4')}>4</button>
                    <button onClick={() => handleButtonClick('5')}>5</button>
                    <button onClick={() => handleButtonClick('6')}>6</button>
                </div>
                <div className="keyboard-row">
                    <button className="hex-letter" onClick={() => handleButtonClick('E')}>E</button>
                    <button className="hex-letter" onClick={() => handleButtonClick('F')}>F</button>
                    <button onClick={() => handleButtonClick('7')}>7</button>
                    <button onClick={() => handleButtonClick('8')}>8</button>
                    <button onClick={() => handleButtonClick('9')}>9</button>
                </div>
                <div className="keyboard-row bottom-row">
                    <button onClick={handleBackspace}>⌫</button>
                    <button className="hex-letter" onClick={togglePopup}>CLOSE</button>
                    <button onClick={() => handleButtonClick('0')}>0</button>
                </div>
            </div>
        </div>
    );
};

export default HexKeyboard;
